import React from 'react'
import { Container, Flex } from '@quark/layout'
import { Text } from '@quark/typography'
import { FilledArrowRightDark } from '@quark/icons'
import { ProductCardProps } from '@interfaces/home'
import { BrandVars } from '@quark/theme'
import { Layer } from '@quark/layer'
import { Domain } from '@enums/Domain'
import styles from './DriveHero.module.scss'
import CardContent from '../Hero/CardContent'

const DriveCard = ({ product, onClick }: { product: ProductCardProps; onClick?: Function }) => (
  <Container
    key={`driveCard-${product?.name}`}
    type="max-parent"
    cursor="pointer"
    backgroundColor='white/200'
    onClick={() =>
      onClick?.(
        product?.eventProperties,
        product?.mobileUrl ?? product?.url ?? '/',
        product?.url ?? '/',
        product?.urlInNewTab,
        product?.modal,
        product?.modalData
      )
    }>
    <Layer
      type="gradient"
      gradient={`linear-gradient(180deg, ${BrandVars.Surface['white/200']} -2.19%, rgba(74, 222, 128, 0.08) 95.42%)`}
    // gradientDark={`linear-gradient(180deg, ${BrandVars.Surface['white/200']} -2.19%, rgba(74, 222, 128, 0.08) 95.42%)`}
    >
      <div className={styles.driveCardContent} style={{ ['--cardBoxShadow' as any]: BrandVars.Shadow['Coloured FX/Small'] }}>
        <Container
          type="max-parent"
          padding={{ lg: 'spacing-24', md: 'spacing-20', sm: 'spacing-16' }}
          textAlign="center">
          <Flex
            size="fullSize"
            flexDirection={{ lg: 'column', md: 'column', sm: 'row' }}
            alignItems="center"
            justifyContent={{ lg: 'center', md: 'center', sm: 'space-between' }}
            gap={{
              lg: 'spacing-24',
              md: 'spacing-16',
              sm: 'spacing-16',
            }}>
            <CardContent
              desktopContent={product?.desktopContent}
              mobileContent={product?.mobileContent}
              domain={Domain.ACKODRIVE}
            />
            {/* <div className={styles.arrow}> */}
            <Text fontStyle={{ lg: 'um_text-4xl/bold', md: 'um_text-2xl/bold', sm: 'um_text-2xl/bold' }} lineHeight="line-height-0" color="base/inverted primary" as="div">
              <FilledArrowRightDark />
            </Text>
            {/* </div> */}
          </Flex>
        </Container>
      </div>
    </Layer>
  </Container>
)

export default DriveCard
